import React, { useState } from 'react';
import './GoldChartOut.css';
import GoldChart from './GoldChart';
const GoldChartOut = () => {
  return (
    <div className='card'>
      <GoldChart/>
    </div>
  );
};
export default GoldChartOut;
